<!--
 * @Description: 批次流通信息
 * @Author: lufenggang
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:52:01
 * @LastEditTime: 2020-12-30 15:37:37
-->
<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        批次流通信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <!-- unlink-panels -->
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.inStorageCode">
            <el-input
              v-model="slotForms.forms.inStorageCode"
              placeholder="入库编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.storageCompanyId">
            <el-select
              v-model="slotForms.forms.storageCompanyId"
              placeholder="园区服务企业名称"
              filterable
              clearable
            >
              <el-option
                v-for="item in storageCompanyList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.foodCompanyId">
            <el-select
              v-model="slotForms.forms.foodCompanyId"
              placeholder="食品经营企业名称"
              filterable
              clearable
            >
              <el-option
                v-for="item in foodCompanyList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.goodsName">
            <el-input
              v-model="slotForms.forms.goodsName"
              placeholder="商品名称/编号"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="入库编号"
          min-width="150"
          prop="warehouseCode"
          fixed
          align="center"
        ></el-table-column>
        <el-table-column
          label="园区服务企业名称"
          min-width="150"
          prop="storageCompany"
          align="center"
        ></el-table-column>
        <el-table-column
          label="入库时间"
          min-width="150"
          prop="warehouseTime"
          align="center"
        ></el-table-column>
        <el-table-column
          label="食品经营企业名称"
          min-width="150"
          prop="foodCompanyName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品名称"
          min-width="150"
          prop="productName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品规格 (mm)"
          min-width="150"
          prop="specification"
          align="center"
        ></el-table-column>
        <el-table-column
          label="数量"
          min-width="100"
          prop="warehouseNumStr"
          align="center"
        ></el-table-column>
        <el-table-column
          label="已出库批次数"
          min-width="100"
          prop="outWarehouseBatchNum"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.outWarehouseBatchNum > 0"
              class="links"
              @click="handleJump(scope.row)"
            >
              {{ scope.row.outWarehouseBatchNum }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="已出库数量"
          min-width="120"
          prop="outWarehouseNum"
          align="center"
        ></el-table-column>
        <el-table-column
          label="未出库数量"
          min-width="120"
          prop="inWarehouseNum"
          align="center"
        ></el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  batchCirculation,
  companyListByType,
  exportBatchCirculation
} from "@/api/goodsTrace/batchCirculation";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { shortcuts } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  name: "goodsTraceBatchCirculation",
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          startTime: "", //开始时间
          endTime: "", //结束时间
          dateRange: [],
          inStorageCode: "", //入库编号
          storageCompanyId: "", //园区服务企业名称id
          foodCompanyId: "", //食品经营企业名称id
          goodsName: "" //商品名称/编号
        },
        extends: []
      },
      //园区服务企业名称列表
      storageCompanyList: [],
      //食品经营企业名称列表
      foodCompanyList: [],
      formsExtend: [],
      tableData: [],
      loading: "false",
      datePickerOptions: {
        shortcuts: shortcuts({ d: [0, -1, -2, -7, -30] }, true, 2)
      }
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    let { code, time } = this.$route.query;
    if (code && time) {
      this.formExtend.forms.inStorageCode = code;
      this.formExtend.forms.dateRange = [
        moment(time)
          .subtract(3, "day")
          .startOf("day")
          .toDate(),
        moment(time).toDate()
      ];
    } else {
      // 条件查询时间范围恢复默认值-今天
      this.formExtend.forms.dateRange = [
        moment()
          .subtract(3, "day")
          .startOf("day")
          .toDate(),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .toDate()
      ];
    }
    // 查询列表数据
    this.fetchFindByPage(this.mergeObj());
    //查询搜索条件
    this.setSearchFormIsOpenAct();
    //加载园区服务企业名称
    this.fetchDictionaries({
      companyType: 2,
      typeName: "仓库园区"
    });
    //加载食品经营企业名称
    this.fetchDictionaries({
      companyType: 1,
      typeName: "食品经营"
    });
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天 && 时间不能为空
    validataTime() {
      let {
        forms: {
          dateRange: [bTime, eTime]
        }
      } = this.formExtend;
      //判断时间间隔不能大于40天
      if (moment(eTime).diff(moment(bTime), "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    //时间格式化
    formatTime(time, type) {
      if (type === "start") {
        return moment(time)
          .startOf("day")
          .valueOf();
      } else {
        return moment(time)
          .endOf("day")
          .valueOf();
      }
    },
    //字典
    fetchDictionaries(params) {
      companyListByType(params)
        .then(res => {
          let { result } = res;
          if (result && Array.isArray(result)) {
            let { companyType } = params;
            if (companyType === 2) {
              this.storageCompanyList = result;
            } else {
              this.foodCompanyList = result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //跳转到流程批次信息页面
    handleJump(row) {
      //跳转路由
      const { href } = this.$router.resolve({
        path: "/goodsTraceOutflowBatch",
        query: {
          outWarehouseId: JSON.stringify(row.outWarehouseBatchDetail),
          time: row.warehouseTime
        }
      });
      window.open(href, "_blank");
    },
    //获取参数
    getParams(params) {
      let {
        storageCompanyId,
        foodCompanyId,
        dateRange: [bTime, eTime]
      } = params;
      let { dateRange, ...paramsObj } = Object.assign(params, {
        startTime: this.formatTime(bTime, "start"),
        endTime: this.formatTime(eTime, "end"),
        storageCompanyId: storageCompanyId ? Array.of(storageCompanyId) : [],
        foodCompanyId: foodCompanyId ? Array.of(foodCompanyId) : []
      });
      return paramsObj;
    },
    // 获取表格数据
    fetchFindByPage(params) {
      let { dateRange } = params;
      if (!dateRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return false;
      }
      if (this.validataTime()) {
        this.loading = true;
        let paramsObj = this.getParams(params);
        let total = 0;
        let tableData = [];
        batchCirculation(paramsObj)
          .then(res => {
            let {
              code,
              result: { data, totalRecords }
            } = res;
            if (res.result && code === 1 && Array.isArray(data)) {
              tableData = data;
              total = totalRecords;
            }
            this.tableData = tableData;
            this.total = total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.getParams(this.mergeObj());
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportBatchCirculation(params).then(res => {
          // 导出
          exportXlsx(res, `批次流通信息.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.fetchFindByPage(this.mergeObj());
    },
    // 重置表单信息
    handleResetForm() {},
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.fetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.fetchFindByPage(this.mergeObj());
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0099ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
</style>
